import { Component, OnInit } from '@angular/core';
import { ErrorCatchService } from '../../../services/common/error-catch.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nopagefound',
  templateUrl: './nopagefound.component.html',
  styleUrls: ['./nopagefound.component.scss']
})
export class NopagefoundComponent implements OnInit {
  textMessage = '';
  public errorMessage: string = '404';
  suggestions: string[] = [''];
  constructor(private errorService: ErrorCatchService, private router: Router) { }

  ngOnInit(): void {
/*     this.errorService.errorMessage$.subscribe(message => {
      this.errorMessage = message;
    }); */
    // Añade la lógica aquí para manejar la URL no válida
    let url = this.router.url;  // Obtiene la URL actual
    if (url.startsWith('/')) { 
      url = url.substring(1); // Quita el '/' al inicio de la URL
      if(url.trim().toLowerCase()=='portal')  this.router.navigate(['/login']);
    }
    this.textMessage = `La página ${url} no se encuentra disponible. Te sugerimos:`;
    this.suggestions = [
      "Recargar la página",
      "Volver a la página anterior",
      "Verificar que la URL esté bien escrita",
      "Contactar al administrador del sistema"
    ];
    
  }

}
